import React from 'react';
import { FiCheckCircle, FiXCircle, FiX } from "react-icons/fi";

const MobileFriendlyNotification = ({ type, message, onClose, autoClose = 5000 }) => {
  const isSuccess = type === "success";
  const icon = isSuccess ? <FiCheckCircle size={20} /> : <FiXCircle size={20} />;
  const bgColor = isSuccess ? "bg-green-500" : "bg-red-500";
  const borderColor = isSuccess ? "border-green-200" : "border-red-200";
  const [isVisible, setIsVisible] = React.useState(true);

  console.log('MobileFriendlyNotification rendering:', { type, message, isSuccess, isVisible });

  React.useEffect(() => {
    if (autoClose && onClose) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Allow fade out animation
      }, autoClose);
      return () => clearTimeout(timer);
    }
  }, [autoClose, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Allow fade out animation
  };

  if (!isVisible) return null;

  return (
    <div
      className={`mobile-notification fixed top-20 left-4 right-4 sm:left-auto sm:right-4 sm:top-20 sm:w-auto sm:max-w-sm flex items-center ${bgColor} text-white shadow-lg rounded-lg px-4 py-3 border ${borderColor} z-[9999] transition-opacity duration-300`}
      style={{ zIndex: 9999 }}
    >
      {/* Icon */}
      <div className="flex-shrink-0 text-white">
        {icon}
      </div>

      {/* Message */}
      <span className="ml-3 text-sm sm:text-base font-medium flex-1">
        {message}
      </span>

      {/* Close Icon */}
      <button
        onClick={handleClose}
        className="ml-auto text-white hover:text-gray-200 flex-shrink-0 transition-colors"
      >
        <FiX size={18} />
      </button>
    </div>
  );
};

export default MobileFriendlyNotification; 